<template>
  <div>
    <vs-tabs v-if="mainTabs.length > 0" :value="currentMainTabIndex">
      <vs-tab v-for="(tab, tabIndex) in mainTabs" :key="`tab_${tab.label}_${tabIndex}`" :label="tab.label" @click="moveMainTab(tab)"></vs-tab>
    </vs-tabs>

    <!-- 검색 폼 -->
    <SearchNav @handleSearch="searchFiles">
      <search-nav-start-end label="업로드일" v-model="search.date" class="mr-4" />
      <search-nav-item-keyword label="서식명" v-model="search.keyword" @keyupEvent="searchFiles" />
    </SearchNav>

    <div class="flex items-end" :class="tabs ? 'justify-between' : 'justify-end'">
      <vs-tabs v-if="tabs" v-model="currTab" class="w-auto">
        <vs-tab label="전체" @click="onClickTab()" />
        <vs-tab v-for="(tab, tabIdx) of tabs" :key="`tab-${tabIdx}`" :label="tab.label" @click="onClickTab(tab)" />
      </vs-tabs>

      <!-- 버튼 -->
      <div v-if="!this.tabs || this.currTab !== 0" class="flex justify-end gap-3 mt-8 mb-4">
        <input ref="fileInput" type="file" style="display: none" @change="handleChangeFile" />
        <vs-button v-if="fileAddPermission" color="secondary" @click="onClickAddBtn">파일추가</vs-button>
        <vs-button v-if="fileDeletePermission" color="secondary" type="border" @click="onClickDeleteBtn">선택삭제</vs-button>
      </div>
    </div>

    <!-- 리스트 -->
    <div>
      <vs-table :multiple="fileDeletePermission" v-model="selected" :data="fileDatas" noDataText="표시할 데이터가 없습니다." class="file-list">
        <template slot="thead">
          <vs-th> 서식명 </vs-th>
          <vs-th> 업로드 시각 </vs-th>
          <vs-th> 업로드 부서 </vs-th>
          <vs-th> 업로드 팀원 </vs-th>
          <vs-th> 파일크기 </vs-th>
          <vs-th> 다운로드 </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              <p class="text-left">
                {{ data[indextr].name }}
              </p>
            </vs-td>
            <vs-td :data="data[indextr].date">
              {{ data[indextr].date }}
            </vs-td>
            <vs-td :data="data[indextr].section">
              {{ data[indextr].section }}
            </vs-td>
            <vs-td :data="data[indextr].uploader">
              {{ data[indextr].uploader }}
            </vs-td>
            <vs-td :data="data[indextr].size">
              {{ data[indextr].size }}
            </vs-td>
            <vs-td>
              <button @click.stop="() => downloadFile(tr.id, tr.boardId, tr.name)" style="background: none" class="border-0 cursor-pointer">
                <feather-icon icon="DownloadIcon" />
              </button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="pagination.lastPage || 1" v-model="pagination.currentPage" @change="handleChangePage"></k-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import KPagination from "@/components/kPagination/kPagination";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import tabItems from "@/views/boards/tab/tab-items";

import config from "/public/config";

export default {
  name: "FileLibraryList",
  components: {
    SearchNavItemSelect,
    SearchNav,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    KPagination,
  },
  props: {
    board: Object,
  },
  computed: {
    boardId() {
      return this.$route.meta.boardId;
    },
    currTabBoardId() {
      if (this.tabs && this.tabs.length > 0) {
        if (this.currTab === 0) return this.tabs.map((tab) => tab.id);
        return this.tabs[this.currTab - 1].id;
      }

      return 0;
    },
    memberInfoBoards() {
      return this.$store.state.member.memberInfo.boards;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    isAdmin() {
      return this.$store.state.member.memberInfo.is_superuser === 1 ? true : false;
    },
    getPermission() {
      const boards = this.memberInfoBoards;
      if (!boards) {
        this.getMemberInfoBoards();
      } else {
        let boardIds = [];
        boardIds.push(parseInt(`${this.boardId}`));
        if (typeof this.currTabBoardId === "object") {
          boardIds.push(...this.currTabBoardId);
        } else if (typeof this.currTabBoardId === "number") {
          boardIds.push(this.currTabBoardId);
        }
        boardIds = [...new Set(boardIds)];

        return boardIds.reduce(
          (acc, curr) => {
            const board = boards.find((b) => parseInt(b.id) === curr && `${this.projectId}` === `${b.pivot.project_id}`);
            if (board && typeof board.pivot !== "undefined") {
              const pivot = { ...board.pivot };
              return {
                c: 0,
                r: pivot.r || acc.r,
                u: pivot.u || acc.u,
                d: pivot.d || acc.d,
                v: pivot.v || acc.v,
              };
            } else return acc;
          },
          { c: 0, r: 0, u: 0, d: 0, v: 0 }
        );
      }
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
    fileAddPermission() {
      return (this.getPermission && this.getPermission.c === 1) || this.isAdmin;
    },
    fileDeletePermission() {
      return (this.getPermission && this.getPermission.d === 1) || this.isAdmin;
    },
    tabs() {
      return this.$route.meta.tabs;
    },
    mainTabs() {
      console.log("route", this.$route.meta);
      return this.$route.meta.mainTabs || [];
    },
    currentMainTabIndex() {
      return this.mainTabs.findIndex((tab) => tab.id === this.boardId);
    },
  },
  data() {
    return {
      tabItems,
      // === Search ===
      search: {
        searchType: "",
        date: "",
        keyword: "",
      },
      currTab: 0,
      // === List ===
      selected: [],
      fileDatas: [],

      pagination: {
        lastPage: 1,
        currentPage: 1,
      },
      searchTypes: [{ text: "서식명", value: "서식명" }],
    };
  },
  created() {
    this.initBreadcrumb();
  },
  methods: {
    async getMemberInfoBoards() {
      const userId = this.$store.state.auth.userInfo.id;
      await this.$store.dispatch("member/LOAD_MEMBER", { userId });
    },
    initBreadcrumb() {
      switch (this.boardId) {
        case 320:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "안전 점검표 서식", active: true }]);
          break;
        case 321:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "안전 계획표 서식", active: true }]);
          break;
        case 322:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "중대시민재해 법령 사항", active: true }]);
          break;
        case 323:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "은평구 현황", active: true }]);
          break;
        case 324:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "재난발생시 조치 매뉴얼", active: true }]);
          break;
        case 325:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "은평구 중대재해 예방 매뉴얼", active: true }]);
          break;
        case 340:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "자료실", active: true }]);
          break;
        case 341:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "자료실", active: true }]);
          break;
        case 342:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "자료실", active: true }]);
          break;
        case 343:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "자료실", active: true }]);
          break;
        case 347:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "자료실", active: true }]);
          break;

        case 413:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "안전·보건 점검", active: true }]);
          break;
        case 418:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "안전·보건 교육", active: true }]);
          break;
        case 423:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "관련 법령 등", active: true }]);
          break;

        case 454:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "중대시민재해예방 업무처리절차" }, { title: "중대시민재해 발생시 대응 매뉴얼", active: true }]);
          break;
        case 455:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "중대시민재해예방 업무처리절차" }, { title: "중대시민재해 예방 업무처리 매뉴얼", active: true }]);
          break;

        // 자료실 현업
        case 545:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "현업" }, { title: "청소", active: true }]);
          break;
        case 546:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "현업" }, { title: "환경미화", active: true }]);
          break;
        case 547:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "현업" }, { title: "경비", active: true }]);
          break;
        case 548:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "현업" }, { title: "시설물 유지관리", active: true }]);
          break;
        case 549:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "현업" }, { title: "공원녹지", active: true }]);
          break;
        case 550:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "현업" }, { title: "조리시설", active: true }]);
          break;
        case 551:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "자료실" }, { title: "현업" }, { title: "기타", active: true }]);
          break;
        case 982:
          this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "산업보건관리" }, { title: "작업측정 관련 법령 등", active: true }]);
          break;
      }
    },
    moveMainTab(tab) {
      if (tab.pageType === "list") {
        const boardId = tab.id;
        const pageType = tab.pageType;
        this.$router.push({ name: "list|tab", params: { pageType, proj_id: this.projectId, boardId } });
      }
    },
    // =================== File Controller Buttons ===================
    // 파일 추가
    onClickAddBtn() {
      this.$refs.fileInput.click();
    },
    async handleChangeFile(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.loading(true);
        await this.$store.dispatch("file/FILE_UPLOAD", files[0]);
        const fileInfo = this.$store.state.file.uploadedFile;
        const boardId = this.tabs ? this.currTabBoardId : this.boardId;

        await this.$store.dispatch("board/UPLOAD_FILE_LIST", {
          boardSlug: `board-${boardId}`,
          uploads: [fileInfo.id],
        });

        this.loadBoardFiles();
      }
      this.$refs.fileInput.value = null;
    },
    // 파일 제거
    async onClickDeleteBtn() {
      if (this.selected.length < 1) return;
      const _confirm = confirm("선택한 파일을 삭제하시겠습니까?");
      if (!_confirm) return;
      const fileIds = this.selected.map((item) => item.id);
      const boardId = this.tabs ? this.currTabBoardId : this.boardId;
      await this.$store.dispatch("board/REMOVE_FILE_LIST", {
        boardSlug: `board-${boardId}`,
        fileIds,
      });

      this.selected = [];
      this.loadBoardFiles();
    },

    // =================== List ===================
    searchFiles() {
      this.pagination.currentPage = 1;
      this.loadBoardFiles();
    },
    async loadBoardFiles() {
      let params = {
        boardIds: typeof this.boardId === "object" ? this.boardId : [this.boardId],
        page: this.pagination.currentPage,
        perPage: 10,
      };

      if (this.tabs && this.tabs.length > 0) {
        if (this.currTab === 0) {
          params.boardIds = this.tabs.map((tab) => tab.id);
        } else {
          params.boardIds = [this.currTabBoardId];
        }
      }

      if (this.search.keyword) params = { ...params, keyword: this.search.keyword };
      if (!!this.search.date.sDate || !!this.search.date.eDate) params = { ...params, dateBegin: this.search.date.sDate, dateEnd: this.search.date.eDate };

      await this.$store.dispatch("board/LOAD_FILE_LIST", params);
      this.loading(false);

      const filesData = this.$store.state.board.fileList;
      this.pagination.lastPage = filesData.last_page;
      this.fileDatas = filesData.data.map((att) => {
        let sizeCheck = att.file_size;
        if (sizeCheck < 1000) sizeCheck = `${sizeCheck}B`;
        else if (sizeCheck < 1000000) sizeCheck = `${(sizeCheck * 0.001).toFixed(1)}KB`;
        else sizeCheck = `${(sizeCheck * 0.000001).toFixed(1)}MB`;

        return {
          id: att.id,
          boardId: att.board_id,
          name: att.file_name,
          date: att.updated_at,
          size: sizeCheck,
          path: att.path,
          uploader: att.user.name,
          section: att.user.section,
        };
      });
    },

    handleChangePage(page) {
      this.pagination.currentPage = page;
      this.loadBoardFiles();
    },

    async downloadFile(fileId, boardId, filename) {
      const token = VueCookie.get("token");
      const boardSlug = `board-${boardId}`;
      fetch(`${config.BASE_API_URL}/api/v1/board/${boardSlug}/download?fileId=${fileId}`, {
        headers: new Headers({
          Authorization: `Bearer ${token}`,
        }),
      }).then((response) => {
        this.loading(true);
        response
          .blob()
          .then((myBlob) => {
            const url = window.URL.createObjectURL(myBlob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
          })
          .finally(() => {
            this.loading(false);
          });
      });
    },

    onClickTab(tab) {
      this.pagination.currentPage = 1;
      this.loadBoardFiles();
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
          text: "처리중 입니다...",
        },
      });
      window.dispatchEvent(loadingDialog);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-list::v-deep {
  background: white;

  .vs-con-tbody {
    border: none;
  }

  tr {
    background: white;
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    transform: translateY(0px) !important;
  }

  th {
    background: #f9f9f9;
    padding: 10px 0 !important;
    & > div {
      display: block;
      color: #3c3c3c;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
    }
  }

  td {
    padding: 10px 0 !important;
    &.td > span {
      display: block;
      color: #3c3c3c;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
